import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import useMixpanel from "hooks/useMixpanel";
import { CUSTOMER_REFERRAL_EVENTS } from "utils/events";

import ArrowSvg from "../../../assets/images/arrows.svg";
import rewardbannerperson from "../../../assets/images/rewardbannerperson.svg";
import { path } from "../../../utils/const";

import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";

const InstantReward = () => {
  const navigate = useNavigate();
  const { track } = useMixpanel();


  const { me } = useSelector((state) => state.app);

  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: 380,
        borderRadius: 4,
        p: 2.5,
        bgcolor: "white",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
        paddingLeft: "2rem",
        paddingRight: "2rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
          width: "100%",
          mb: "12px",
        }}
      >
        <Box
          sx={{
            flex: 1,
            height: "1px",
            background:
              "linear-gradient(90deg, transparent 0%, #E0E0E0 50%, #E0E0E0 100%)",
            maxWidth: "100px",
          }}
        />
        <Typography
          sx={{
            fontSize: "12px",
            fontFamily: "Manrope",
            fontWeight: 500,
            lineHeight: "100%",
            letterSpacing: "0.8px",
            color: "rgba(0, 0, 0, 0.84)",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
            px: 1,
          }}
        >
          INSTANT REWARD 🎉
        </Typography>
        <Box
          sx={{
            flex: 1,
            height: "1px",
            background:
              "linear-gradient(90deg, #E0E0E0 0%, #E0E0E0 50%, transparent 100%)",
            maxWidth: "100px",
          }}
        />
      </Box>

      <Box
        sx={{
          width: "100%",
          height: "90px",
          borderRadius: "15px",
          border: "1px solid #E9E9E9",
          background: "linear-gradient(90deg, #D3FFFC 0%, #FFFFFF 100%)",
          boxShadow: "0px 4px 16px rgba(51, 51, 51, 0.08)",
          display: "flex",
          alignItems: "center",
          position: "relative",
          overflow: "hidden",
          mb: "14px",
        }}
      >
        <Box
          sx={{
            width: "75px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            position: "absolute",
            left: 0,
            top: 0,
            paddingLeft: "12px",
          }}
        >
          <img
            src={rewardbannerperson}
            alt="Reward illustration"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              objectPosition: "left center",
            }}
          />
        </Box>

        <Box
          sx={{
            flex: 1,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            pl: "105px",
            pr: "12px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-end", gap: "6px" }}>
            <Typography
              sx={{
                fontFamily: "Manrope",
                fontWeight: 700,
                fontSize: "15px",
                color: "#F36333",
                lineHeight: 1,
              }}
            >
              EARN
            </Typography>
            <Typography
              sx={{
                fontFamily: "Manrope",
                fontWeight: 700,
                fontSize: "21px",
                color: "#F36333",
                lineHeight: 1,
              }}
            >
              ₹5000
            </Typography>
            <Typography
              sx={{
                fontFamily: "Manrope",
                fontWeight: 700,
                fontSize: "16px",
                color: "#F36333",
                lineHeight: 1,
              }}
            >
              instantly!
            </Typography>
          </Box>

          <Typography
            component="div"
            sx={{
              fontFamily: "Manrope",
              fontWeight: 500,
              fontSize: "11px",
              color: "#000000",
              lineHeight: "16px",
              mt: "8px",
            }}
          >
            for every new customer who completes
            <br />
            their first{" "}
            <Box
              component="span"
              onClick={() => navigate(path.customerReferralTermsAndConditions)}
              sx={{
                fontWeight: 700,
                textDecoration: "underline",
                whiteSpace: "nowrap",
                color: "rgba(9, 141, 131, 1)",
                cursor: "pointer",
              }}
            >
              Green Transaction*
            </Box>{" "}
            on FruitX.
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          height: "1px",
          background: "#E0E0E0",
          mb: "12px",
        }}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "1px",
          pt: "4px",
          pb: "4px",
        }}
      >
        <Typography
          sx={{
            color: "#1A1A1A",
            fontFamily: "Manrope",
            fontWeight: 600,
            fontSize: "14px",
            lineHeight: 1.3,
            mb: "4px",
          }}
        >
          What is a Green transaction? 🌱
        </Typography>

        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 400,
            color: "#666666",
            textAlign: "justify",
            lineHeight: 1.6,
            fontFamily: "Manrope",
          }}
        >
          First Green Transaction means that the referred customer procures a
          minimum of 12 tons of material from FruitX mandi and the customer
          completes full payment for the purchased material is completed within
          seven (7) days of procurement, with the entire invoice amount fully
          settled. More details in Terms and Conditions.
        </Typography>
      </Box>

      <Box
        onClick={() => {
          track(CUSTOMER_REFERRAL_EVENTS.TERMS_CONDITION, {
            customer_id: me?.customerId,
            customer_name: me?.fullName,
            email: me?.email,
            timestamp: new Date().toISOString(),
            source: "know_more",
          });
          navigate(path.customerReferralTermsAndConditions);
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: "pointer",
          mt: 2,
          "&:hover": {
            "& .arrow-icon": {
              transform: "translateX(2px)",
            },
            "& .know-more-text": {
              textDecoration: "underline",
            },
          },
        }}
      >
        <Typography
          className="know-more-text"
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            color: "#00A991",
            fontFamily: "Manrope",
          }}
        >
          Know more
        </Typography>
        <Box
          component="img"
          src={ArrowSvg}
          alt="Arrow"
          className="arrow-icon"
          sx={{
            width: "14px",
            height: "14px",
            transition: "transform 0.2s ease",
          }}
        />
      </Box>
    </Card>
  );
};

export default InstantReward;
